import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { normalizeEmptyResponseToSuccessResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/infrastructure';
import { ISecurityPreferencesRepository } from '../entities/ISecurityPreferencesRepository';
import { ChangePasswordAuthorizationResponseBody } from '../entities/ChangePasswordAuthorizationResponseDTO';
import { ChangeUsernameAuthorizationResponseBody } from '../entities/ChangeUsernameAuthorizationResponseDTO';
import { PasswordPolicy, UsernameRule } from '../entities';
import { passwordPolicyDTOToPasswordPolicyAdapter, usernameRuleDTOToUsernameRuleAdapter } from './';

class SecurityPreferencesRepositoryImpl implements ISecurityPreferencesRepository {
  constructor() {
    this.GetChangePasswordAuthorization = this.GetChangePasswordAuthorization.bind(this);
    this.ChangePassword = this.ChangePassword.bind(this);
    this.PasswordPolicy = this.PasswordPolicy.bind(this);
    this.ChangeUsernameAuthorization = this.ChangeUsernameAuthorization.bind(this);
    this.ChangeUsername = this.ChangeUsername.bind(this);
    this.UsernameRule = this.UsernameRule.bind(this);
  }

  GetChangePasswordAuthorization(): Promise<ChangePasswordAuthorizationResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/private/users/password/authorization',
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  ChangePassword(data?: {
    requestId: string;
    currentPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
  }): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'PUT',
        url: '/secure-web/api/private/users/password',
        data,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  PasswordPolicy(): Promise<PasswordPolicy[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/private/users/password/policy',
        dataAdapter: passwordPolicyDTOToPasswordPolicyAdapter,
      },
    });
  }

  ChangeUsernameAuthorization(newUsername: string): Promise<ChangeUsernameAuthorizationResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: '/secure-web/api/private/users/username/authorization',
        data: { newUsername },
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  UsernameRule(): Promise<UsernameRule[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/private/users/username/rules',
        dataAdapter: usernameRuleDTOToUsernameRuleAdapter,
      },
    });
  }

  ChangeUsername(requestId: string): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'PUT',
        url: '/secure-web/api/private/users/username',
        data: { requestId },
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }
}

export { SecurityPreferencesRepositoryImpl };
